import {exportAuditLogs} from 'audit/AuditActions';
import {EXPORT_RESULT_AUDIT_LOG_DISPLAY_STRING} from 'audit/AuditConstants';
import makeSimpleActionFunction from 'notebook/structured-tables/action-functions/makeSimpleActionFunction';
import {TableActionFunctionParameters} from 'notebook/structured-tables/StructuredTableConstants';
import notifications from 'notifications';

import {ResultsRowMetadata, ResultsTableMetadata} from './ResultsTableConstants';

export const exportResultsTableAuditLogsActionFunction = makeSimpleActionFunction<
  ResultsTableMetadata,
  ResultsRowMetadata
>({
  label: 'Export table audit logs',
  icon: 'audit-trail',
  iconAltText: 'Export results table logs',
  onInvoke: ({structuredTable}) => {
    exportAuditLogs([structuredTable.apiId ?? '']);
  },
});

export type OnInvokeExportResultsAuditLogsParameters = Pick<
  TableActionFunctionParameters<ResultsTableMetadata, ResultsRowMetadata>,
  'structuredTable'
>;

export const NO_RESULTS_TO_EXPORT_WARNING = 'There are no results present.';

export function onInvokeExportResultsAuditLogsActionFunction({
  structuredTable,
}: OnInvokeExportResultsAuditLogsParameters): void {
  const tableResultsWarehouseIds = structuredTable.rows
    .filter((row) => row.metadata.euid != null)
    .map((row) => row.metadata.euid as string);
  if (tableResultsWarehouseIds.length === 0) {
    notifications.warn(NO_RESULTS_TO_EXPORT_WARNING);
    return;
  }
  exportAuditLogs([], {resultsWarehouseIds: tableResultsWarehouseIds});
}

export const exportResultsAuditLogsActionFunction = makeSimpleActionFunction<
  ResultsTableMetadata,
  ResultsRowMetadata
>({
  label: EXPORT_RESULT_AUDIT_LOG_DISPLAY_STRING,
  icon: 'audit-trail',
  iconAltText: EXPORT_RESULT_AUDIT_LOG_DISPLAY_STRING,
  onInvoke: onInvokeExportResultsAuditLogsActionFunction,
});
